import React from 'react'
import Layout from '../../../layout/Layout'
import RulesList from 'components/organisms/RulesList/RulesList'
import HeaderPageSection from 'components/molecules/HeaderPageSection/HeaderPageSection'
import AppButton from 'components/atoms/AppButton/AppButton'
import { useNavigate } from 'react-router-dom'
import { usePermissions } from 'hooks/usePermissions'
import { RolePermissions } from 'utils/constants'

export default function RulesListPage() {
    const navigate = useNavigate()
    const { can } = usePermissions()
    return (
        <Layout>
            <HeaderPageSection title="Reglas" showGoBack={false}>
                <div>
                    {can(RolePermissions.rules.create) && (
                        <AppButton
                            title="Crear regla"
                            state="primary"
                            className="text-sm font-bold"
                            onClick={() => navigate('/rules/create')}
                        />
                    )}
                </div>
            </HeaderPageSection>
            <RulesList />
        </Layout>
    )
}
